import { X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button.tsx";
import {
  GicsLevelBadge,
  type GicsTreeNode,
  IndustryBrowserDialog,
  type SelectedIndustry,
} from "@/lib/industry";
import { cn } from "@/lib/utils.ts";

export type { SelectedIndustry };

interface IndustryFilterProps {
  value: SelectedIndustry | null;
  onChange: (value: SelectedIndustry | null) => void;
  treeData: GicsTreeNode[];
}

export function IndustryFilter({
  value,
  onChange,
  treeData,
}: IndustryFilterProps) {
  const [open, setOpen] = useState(false);

  const handleSelect = (industry: SelectedIndustry) => {
    onChange(industry);
    setOpen(false);
  };

  const handleClear = () => {
    onChange(null);
  };

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className={cn("justify-between min-w-[180px]", value && "pr-1")}
      >
        {value ? (
          <div className="flex items-center gap-2 overflow-hidden">
            <GicsLevelBadge level={value.level} />
            <span className="truncate">{value.name}</span>
          </div>
        ) : (
          <span className="text-muted-foreground">Industries</span>
        )}
        {value && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleClear();
            }}
            className="ml-1 p-1 rounded hover:bg-muted text-muted-foreground hover:text-foreground"
          >
            <X className="h-3 w-3" />
          </button>
        )}
      </Button>

      <IndustryBrowserDialog
        open={open}
        onOpenChange={setOpen}
        onSelect={handleSelect}
        currentValue={value}
        treeData={treeData}
        title="Browse Industries"
        description="Select any GICS level to filter accounts"
      />
    </>
  );
}
